import type { Breadcrumb, ErrorEvent } from '@sentry/react';
import { redactWebviewSession } from './posWebviewSession';

type BreadcrumbData = NonNullable<Breadcrumb['data']>;

const redactStrings = (data: BreadcrumbData): BreadcrumbData =>
  Object.fromEntries(
    Object.entries(data).map(([key, value]) => [key, typeof value === 'string' ? redactWebviewSession(value) : value]),
  );

/** A second layer behind the early strip: no breadcrumb may carry a session token. */
export const scrubBreadcrumb = (breadcrumb: Breadcrumb): Breadcrumb => {
  const scrubbed = { ...breadcrumb };
  if (scrubbed.message) {
    scrubbed.message = redactWebviewSession(scrubbed.message);
  }
  if (scrubbed.data) {
    scrubbed.data = redactStrings(scrubbed.data);
  }
  return scrubbed;
};

export const scrubEvent = (event: ErrorEvent): ErrorEvent => {
  const scrubbed = { ...event };
  if (scrubbed.message) {
    scrubbed.message = redactWebviewSession(scrubbed.message);
  }
  if (scrubbed.request?.url) {
    scrubbed.request = { ...scrubbed.request, url: redactWebviewSession(scrubbed.request.url) };
  }
  if (scrubbed.breadcrumbs) {
    scrubbed.breadcrumbs = scrubbed.breadcrumbs.map(scrubBreadcrumb);
  }
  return scrubbed;
};
